var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91752 8.33333H5.83333V6.66667C5.83333 4.36548 7.69882 2.5 10 2.5C12.3012 2.5 14.1667 4.36548 14.1667 6.66667V8.33333H14.0825M10 11.6667V13.3333M15.8333 12.5C15.8333 15.7217 13.2217 18.3333 10 18.3333C6.77834 18.3333 4.16667 15.7217 4.16667 12.5C4.16667 9.27834 6.77834 6.66667 10 6.66667C13.2217 6.66667 15.8333 9.27834 15.8333 12.5Z",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock2);
export default __webpack_public_path__ + "static/media/lock-2.7ebabe8cc6f9962c80990469ac45a4a3.svg";
export { ForwardRef as ReactComponent };